module.exports = __webpack_public_path__ + "img/vichy 2025.28b606f3.webp";